import React,{useEffect} from "react";
import normatecaStore from "../../../stores/normatecaStore";

export default function MasLeido(){
    const imgurl = process.env.REACT_APP_IMG_URL + "normateca/"; 
    const imgico = process.env.REACT_APP_IMG_URL + "ico/";
    const nas = process.env.REACT_APP_NAS;
    const {setMasLeido,jsonMasLeido} =
    normatecaStore((state) =>( { 
        setMasLeido: state.setMasLeido,
        jsonMasLeido: state.jsonMasLeido,
     })); 
     useEffect(() => {
        setMasLeido().catch(null);
      }, []);
    return(
        <div>
            <div className="divTit">
                <div className="titpublicRes">Lo más leído</div>
                <div className="linepublicRes"></div>
            </div>
            <div className="divloML">
                <div className="divScroll">
                    {jsonMasLeido?.map((ia, index)=>(
                        <div key={"ia" + index.toString()} className="display-flex divIndv">
                            <div className="divImgs"><a href={nas + ia.archivo} target="_blank">
                                <img src={ imgurl + ia.img} /></a>
                            </div>
                                <div className="divMLInfo">{ia.titulo}<br/>
                                    <span className="font-normal">{ia.fecha}</span>
                                </div>
                                <div className="alignSelf-center txt-align-right whiteSpace-nowrap">
                                    <a href={nas + ia.archivo } target="_blank"><img src={imgico + "ico_pdf.png" } /></a><br/>
                                    <span className="font-normal padleft-05">{ia.tamaño}</span>
                                </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}